<template>
  <div>
    <div class="page-header">
      <h3 class="capitalize">{{ $t(nameLocalization()) }}</h3>
      <small v-if="hideComletedTasks" class="pointer" @click="toggleCompletedTasks">Show Completed Tasks</small>
      <small v-if="!hideComletedTasks" class="pointer" @click="toggleCompletedTasks">Hide Completed Tasks</small>
    </div>
    <TaskExpander />
    <NewQuickTask :tier1="tier1"/>

    <ul class="mt-2 list-group">
      <draggable v-model="allTasks" @start="drag=true" @end="drag=false" handle=".sort-handle">
        <transition-group type="transition" :name="'flip-list'">
          <li v-for="task in allTasks" :key="task.id" :class="rowStyle($t('tier1.' + task.tier1 + '.color'))">
            <QuickTask :task="task" :sortable=true />
          </li>
        </transition-group>
      </draggable>
    </ul>
  </div>
</template>

<script>
import QuickTask from "components/QuickTask";
import NewQuickTask from "components/NewQuickTask";
import TaskExpander from "components/TaskExpander";
import draggable from 'vuedraggable'

export default {
  components: {
    QuickTask,
    NewQuickTask,
    TaskExpander,
    draggable
  },
  props: {
    tier1: {
      type: String
    }
  },
  data() {
    return {
      hideComletedTasks: true
    };
  },  
  computed: {
    allTasks: { 
      set: function(value){
        var ordered_ids = []
        value.forEach(function(item, index){
          ordered_ids.push(item.id)
        })

        var payload = {
          name: 'tier1' + this.tier1,
          ordered_ids: ordered_ids
        }
        store.commit('updateSortedGroup', payload)

        return value;
      },
      get: function(){
        return store.getters.sortedTier1Tasks(this.tier1, this.hideComletedTasks)
      }
    }
  },
  methods: {
    toggleCompletedTasks(){
      this.hideComletedTasks = !this.hideComletedTasks
    },
    nameLocalization: function(){
      return "tier1." + this.tier1 + ".name"
    },
    rowStyle(tier1Color){
      if(tier1Color){
        return "list-group-item js-task-details-collapse-container border border-" + tier1Color
      } else {
        return "list-group-item js-task-details-collapse-container border"
      }
    },
  }
};
</script>
